module.exports = __webpack_public_path__ + "static/media/saveOrderIcon.3a75830b.svg";